import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributing",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#contributing",
        "aria-label": "contributing permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Contributing`}</h1>
    <h2 {...{
      "id": "installing",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#installing",
        "aria-label": "installing permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Installing`}</h2>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` was built and tested with Node version 8+. Installing `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# download project`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone git@github.com:mockyeah/mockyeah.git
$ `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` mockyeah

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# install proper Node version`}</span>{`
$ nvm `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` v8.16.0
$ nvm use

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# install dependencies and link monorepo modules`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# if tests pass, you're good to go`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`test`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` start`}</code></pre></div>
    <p>{`Open the `}<a parentName="p" {...{
        "href": "http://127.0.0.1:8000"
      }}>{`docs site at http://127.0.0.1:8000`}</a>{`.`}</p>
    <h2 {...{
      "id": "troubleshooting",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#troubleshooting",
        "aria-label": "troubleshooting permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Troubleshooting`}</h2>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` is a monorepo project, the dev tool `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`lerna`}</code>{` is required to connect the sub-modules in the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`./packages`}</code>{` directory.
If `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`lerna`}</code>{` doesn't run when you install the dependencies you can run it manually:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ npx lerna bootstrap

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# continue to run, build, and test`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`test`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` start`}</code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      